import { render, staticRenderFns } from "./StepViewDefaulaaat.vue?vue&type=template&id=5634d85d&scoped=true"
import script from "./StepViewDefaulaaat.vue?vue&type=script&lang=js"
export * from "./StepViewDefaulaaat.vue?vue&type=script&lang=js"
import style0 from "./StepViewDefaulaaat.vue?vue&type=style&index=0&id=5634d85d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5634d85d",
  null
  
)

export default component.exports